import { render, staticRenderFns } from "./LocationSettingsPlatforms.vue?vue&type=template&id=a6dee2a2&scoped=true"
import script from "./LocationSettingsPlatforms.vue?vue&type=script&lang=js"
export * from "./LocationSettingsPlatforms.vue?vue&type=script&lang=js"
import style0 from "./LocationSettingsPlatforms.vue?vue&type=style&index=0&id=a6dee2a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dee2a2",
  null
  
)

export default component.exports